import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LoginComponent } from '../auth/components/login/login.component';

// Single place that opens the login dialog so every "this needs a session token"
// guard across the app (pre-flight loggedIn() checks, the 401 interceptor) looks
// and behaves the same way, instead of each call site inventing its own snackbar.
@Injectable({
  providedIn: 'root'
})
export class LoginPromptService {
  private dialogOpen = false;

  constructor(private dialog: MatDialog) {}

  open(): void {
    if (this.dialogOpen) return;
    this.dialogOpen = true;
    const ref = this.dialog.open(LoginComponent, {
      panelClass: 'login-dialog',
      width: '860px',
      maxWidth: '96vw',
    });
    ref.afterClosed().subscribe(() => { this.dialogOpen = false; });
  }
}
